!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):e.dayjs_plugin_weekOfYear=t()}(this,function(){"use strict";return function(e,t,i){var n=t.prototype;n.week=function(e){if(void 0===e&&(e=null),null!==e)return this.add(7*(e-this.week()),"day");var t=this.$locale().weekStart||0,n=i(this).startOf("year"),o=n.subtract(n.day()-t,"day").subtract(1,"millisecond"),r=this.diff(o,"week",!0),u=Math.ceil(r);return u>52?1:u},n.weeks=function(e){return void 0===e&&(e=null),this.week(e)}}});



//////////////////
// WEBPACK FOOTER
// ./node_modules/dayjs/plugin/weekOfYear.js
// module id = sTI9
// module chunks = 32